<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
          <j-editable-table
            :ref="refKeys[0]"
            :loading="stkIoBillEntryTable.loading"
            :columns="stkIoBillEntryTable.columns"
            :dataSource="stkIoBillEntryTable.dataSource"
            :maxHeight="300"
            :rowNumber="false"
            :rowSelection="true">
          </j-editable-table>
    </a-spin>
  </j-modal>
</template>

<script>
  import pick from 'lodash.pick'
  import {FormTypes, getRefPromise} from '@/utils/JEditableTableUtil'
  import {JEditableTableMixin} from '@/mixins/JEditableTableMixin'
  import JDate from '@/components/jeecg/JDate'
  import JUpload from '@/components/jeecg/JUpload'
  import JSelectUserByDep from '@/components/jeecgbiz/JSelectUserByDep'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import {getAction, putAction,postAction} from '@api/manage'
  import {billModalMixin} from '../../mixins/billModalMixin'
  import OnlCgreportSelectModal from '../../components/OnlCgreportSelectModal'
  import EditableTableColumnsSetter from "../../components/EditableTableColumnsSetter";
  import {getFormatDate} from '../../utils/util'
  import {validateEntryNo} from '../../utils/editableTableValidate'

  export default {
    name: 'MoveBillStockModal',
    mixins: [JEditableTableMixin, billModalMixin],
    components: {
      EditableTableColumnsSetter,
      JDate,
      JUpload,
      JSelectUserByDep,
      JDictSelectTag,
    },
    data() {
      return {
        title:"调入明细",
        width: '1200px',
        moreStatus: false,
        visible:false,
        refKeys: ['moveBillStock'],
        tempProps: {},
        url: {
          add: "/stock/stkIoBill/add",
          edit: "/stock/stkIoBill/edit",
          approve: "/stock/stkIoBill/approve",
          confirm: "/stock/stkIoBill/confirmStock",
          stkIoBillEntry: {
            list: '/stock/stkIoBill/queryEntryByMainId',
            editingList: '/stock/stkIoBill/queryEditingEntryByMainId'
          },
          getUnitMapper:"/bas/basMaterial/getMapperUnitIdBySign",
          getWareHouseId: "/bas/basWarehouse/queryWarehouseIdByUserCode",
          queryMaterialByCodeOrName: "/bas/basMaterial/queryByCodeOrName",
        },
        // 明细
        stkIoBillEntryTable: {
          loading: false,
          dataSource: [],
          columns: [
            {
              title: '分录号',
              key: 'entryNo',
              type: FormTypes.inputNumber,
              width: "60px",
              disabled: true
            },
            {
              title: '物料',
              key: 'materialId',
              type: FormTypes.select,
              dictCode: "bas_material,name,id",
              width: "200px",
              disabled: true
            },
            {
              title: '批次号',
              key: 'batchNo',
              type: FormTypes.input,
              width: "200px",
              placeholder: '请输入${title}',
              disabled: true
            },
            {
              title: '调出仓库',
              key: 'warehouseId',
              type: FormTypes.select,
              dictCode: "bas_warehouse,name,id",
              width: "150px",
              disabled: true
            },
            {
              title: '调入仓库',
              key: 'inWarehouseId',
              type: FormTypes.hidden,
              dictCode: "bas_warehouse,name,id",
              width: "150px",
              disabled: true
            },
            {
              title: '调拨单位',
              key: 'unitId',
              type: FormTypes.select,
              dictCode: "bas_measure_unit,name,id",
              width: "100px",
              placeholder: '请输入${title}',
              disabled: true,
            },
            {
              title: '调拨数量',
              key: 'qty',
              type: FormTypes.inputNumber,
              statistics: "true",
              width: "100px",
              disabled: true,
            },
            {
              title: '实到数量',
              key: 'realQty',
              disabled: false,
              type: FormTypes.inputNumber,
              statistics: "true",
              width: "100px",
              disabled: false,
            },
            {
              title: '源库存批次id',
              key: 'inventoryId',
              type: FormTypes.hidden,
              width: "10px",
              disabled: true,
            },
            {
              title: '备注',
              key: 'remark',
              type: FormTypes.input,
              width: "200px",
              placeholder: '请输入${title}',
              defaultValue: '',
            },
          ],
        },
      }
    },
    created() {
    },
    methods: {
      editTable(record) {
        debugger
        this.model = Object.assign({}, record);
        this.visible = true;
        if (this.model.id) {
          let params = {id: this.model.id}
          let url = this.readOnly ? this.url.stkIoBillEntry.list : this.url.stkIoBillEntry.editingList;
          this.requestSubTableData(url, params, this.stkIoBillEntryTable);
        }
      },
      /** 整理成formData */
      classifyIntoFormData(allValues) {
        let main = Object.assign(this.model, allValues.formValue)

        return {
          ...main, // 展开
          stkIoBillEntryList: allValues.tablesValue[0].values,
        }
      },
      handleOk () {
        const that = this;
        that.getAllTable().then(table => {
          table[0].getAll().then(tablevalue => {
            that.model.stkIoBillEntryList = JSON.stringify(tablevalue.values)
            let formData = {
              id: that.model.id,
              stkIoBillEntryList: that.model.stkIoBillEntryList
            }
            console.log("表单提交数据", formData)
            that.confirmLoading = true;
            postAction(this.url.confirm, formData).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.error(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          })
        })
      },
    },
  }
</script>

<style lang="less" scoped>
  .ant-row.ant-form-item {
    margin-bottom: 12px;
  }
</style>
